var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"holder",staticClass:"tempt"},[(_vm.shouldLoad && _vm.src)?_c('screen-img',{attrs:{"src":_vm.src,"classOption":_vm.classOption}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }